import { Flex, Spinner, Text, View } from '@smarterservices/smarter-ui';
import { usePlayerStore } from '../../../stores/StoreContext';
import CONSTANTS from '../../../config/constants';

const Disconnected = () => {
const overlay = usePlayerStore((state) => state.overlay);
const isLive = usePlayerStore((state) => state.isLive);

    if(overlay === CONSTANTS.OVERLAYS.PLAYBACK_COMPLETE && !isLive){
        return null;
    }

  return (
    <Flex
        direction="column"
        alignItems="center"
        justifyItems="center"
        height="100%"
    >
    <Spinner 
            size="x-small" 
            variant='inverse'
            renderTitle="Test Taker Stream Disconnected"
            themeOverride={{
                inverseColor: '#FFF'
            }} 
            />
            <View as="div" textAlign="center">
                <Text as="p" textAlign="center" size="x-small" color="primary-inverse">
                    Test Taker
                </Text>
                <Text as="p" textAlign="center" size="x-small" color="primary-inverse">
                    Stream Disconnected
                </Text>
            </View>    
    </Flex>   
    );
}
export default Disconnected;